<template>
	<div class="section">
		<div class="container breathe">
			<div class="columns">
				<div class="column">
					<div class="has-text-centered" v-if="!loading">
						Thank you for your request for free access to the CTC Compliance Index.
						<br />
						Please check your email for an account confirmation link.
						<br />
						<br />
						<a href="javascript://" @click="resend" v-if="email">
							Did not receive an email? Click this link to send again.
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				loading: true,
				email: undefined,
				code: undefined
			};
		},
		methods: {
			resend() {
				this.$store.dispatch("freeAccess", { Email: this.email }).then((resp) => {
					if (resp == "User already exists") {
						this.$buefy.notification.open({
							duration: 4000,
							message: "Please use credentialed user login",
							type: "is-danger"
						});
					} else if (resp == "Confirm Email") {
						this.$buefy.notification.open({
							duration: 4000,
							message: "An email has been sent with your confirmation link.",
							type: "is-success"
						});
					}
				});
			}
		},
		created() {
			this.email = this.$route.params.email;
			this.code = this.$route.params.code;
			if (this.code && this.code != "freeAccess") {
				this.$store.dispatch("loginFree", { email: this.email, code: this.code }).then((resp) => {
					this.$router.push("/index");
				});

				// this.$http
				// 	.post("/api/freeUser/access/" + this.email + "/" + this.code)
				// 	.then((resp) => {
				// 		if (resp.data.success) {
				// 			//Log in automatically
				// 			//this.resend();
				// 		}
				// 	})
				// 	.catch((err) => {
				// 		this.$buefy.notification.open({
				// 			duration: 4000,
				// 			message: "A problem occurred trying to grant access. Please try again later.",
				// 			type: "is-danger"
				// 		});
				// 	});
			} else {
				this.loading = false;
			}
		}
	};
</script>
